import React from 'react';

const ShopPage: React.FC = () => {
  return <h1>Shop – E-shop s obrazy</h1>;
};

export default ShopPage;
